import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {InfoBubblePillVariantsEnum} from '../../../../../libs/shared/ui/src/components/tip/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Props.
 */

interface RulesIntroEducationTip extends SandboxEducationTipProps {
  onExpandClick: () => void;
}

/*
 * Component.
 */

export const RulesIntroEducationTip: FC<RulesIntroEducationTip> = (props) => {
  const {anchor, isVisible, onExpandClick} = props;
  return (
    <EducationTip
      anchor={anchor}
      position="left-start"
      isVisible={isVisible}
      isStandalone
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={<Trans id="infobubble-onboarding-rules-intro-title">Front rules help boost efficiency</Trans>}
      stepCounter={generateStepText(2, 4)}
      dataObjectName={OnboardingDataEventObject.DEMO_RULES_INTRO}
      primaryActionLabel={<Trans id="infobubble-onboarding-rules-intro-primary-action-label">Next</Trans>}
      onPrimaryClick={onExpandClick}
    >
      <Trans id="infobubble-onboarding-rules-intro-description">
        Expand the activity line to see examples of automated rules that help get requests to the right team
        members quickly.
      </Trans>
    </EducationTip>
  );
};
